module.exports = __webpack_public_path__ + "static/media/LigaOlimpiadasLogo.bde53fe3.png";